import { SxProps, Theme } from '@mui/material/styles';
import colors from '../../config/Colors.config';

const sx: SxProps<Theme> = {
    '& .MuiOutlinedInput-notchedOutline': {
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: 0,
        borderBottom: `1px solid ${colors.secundario}`,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: 0,
        borderBottom: `1px solid ${colors.secundario}`,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: 0,
        borderBottom: `1px solid ${colors.secundario}`,
    },
    width: "100%"
};

const SelectStyle = {
    sx,
};

export default SelectStyle;